export default {
  HOME_PAGE: "HomePage",
  CLINICAL_SERVICES: "ClinicalServices",
  HOME_DELIVERY: "HomeDelivery",
  SPECIALTY: "Specialty",
  GOVERNMENT_PROGRAMS: "GovernmentPrograms"
};
